import { render, staticRenderFns } from "./NewAgreement.vue?vue&type=template&id=2436bba1&scoped=true&"
import script from "./NewAgreement.vue?vue&type=script&lang=js&"
export * from "./NewAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436bba1",
  null
  
)

export default component.exports